import React from "react";
import { StyledSwipeableDrawer, StyledTypography } from "../../../../../styled-mui";
import MobileMenuWrapper from "../MobileMenuWrapper";
import { useNavigate } from "react-router";
import useFetchWpPosts from "../../../../../_foundation/hooks/use-wordpress-posts";
import { StyledMenuButton } from "../../style";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box } from "@mui/material";
import { ImageLayout } from "../../../../elements/image";
import HTMLReactParser from "html-react-parser";
import { StyledChip } from "../../../../../../src/styled-mui/chip/styled-chip";
import SmartLink from "../../../../elements/smart-link/smart-link";
import AsyncCall from "../../../../../_foundation/gtm/async.service";
import storeUtil from "../../../../../utils/storeUtil";

interface Props {
  open: boolean;
  entireMenuCloseHandler: () => any;
  closeCurrentMenu: () => any;
  menuLinksData: Record<string, any>;
}

const MobileInspirationsMenu: React.FC<Props> = ({ open, entireMenuCloseHandler, closeCurrentMenu, menuLinksData }) => {
  const InspirationData = menuLinksData?.magazine;
  const navigate = useNavigate();
  const { data: wpPostData } = useFetchWpPosts(!!InspirationData?.postsId, { postsId: InspirationData?.postsId });

  const onLinkClick = (item: Record<string, any>) => {
    AsyncCall.sendPageClickCtaEvent({ btn_label: item?.label || "" });
    entireMenuCloseHandler();
  };

  const onButtonClick = () => {
    entireMenuCloseHandler();
    navigate("/c/magazine");
  };

  return (
    <StyledSwipeableDrawer
      anchor="left"
      open={open}
      onClose={closeCurrentMenu}
      onOpen={() => null}
      className="header-menu-level2 mobile-inspirations-menu">
      <MobileMenuWrapper
        title="Inspiration & conseils"
        isASubMenu
        entireMenuCloseHandler={entireMenuCloseHandler}
        closeCurrentMenu={closeCurrentMenu}>
        <Box padding={3}>
          {wpPostData &&
            wpPostData?.map((wpPost: Record<string, any>, index: number) => {
              const featuredMedia = wpPost?._embedded?.["wp:featuredmedia"]?.[0]?.media_details?.sizes;
              const imgSrc = featuredMedia?.medium_large?.source_url || featuredMedia?.medium?.source_url || "";
              const imgAltText = wpPost?._embedded?.["wp:featuredmedia"]?.[0]?.alt_text || "";
              const chipName = HTMLReactParser(wpPost?._embedded["wp:term"]?.[0]?.[0]?.name) || "";
              const title = HTMLReactParser(wpPost?.title?.rendered) || "";
              return (
                <SmartLink
                  isExternal
                  className="inspiration-mobile-card"
                  key={wpPost?.id}
                  to={wpPost?.link}
                  onClick={() => onLinkClick({ label: title })}
                  styles={{
                    display: "flex",
                    border: "1px solid rgba(224, 224, 224, 1)",
                    borderRadius: "8px",
                    marginBottom: "12px",
                    overflow: "hidden",
                  }}>
                  <ImageLayout src={imgSrc} alt={imgAltText} width={90} styles={{ margin: "unset" }} />
                  <Box padding={3}>
                    <StyledChip size="small" label={chipName} variant="outlined" className="white" />
                    <StyledTypography
                      variant="subtitle2"
                      component="p"
                      className="advice-card-title"
                      style={{
                        fontSize: "13px",
                        lineHeight: "16px",
                        marginTop: "4px",
                        color: "#212121",
                      }}>
                      {title}
                    </StyledTypography>
                  </Box>
                </SmartLink>
              );
            })}
          <StyledMenuButton onClick={onButtonClick}>
            Voir tous nos articles
            <ArrowForwardIcon />
          </StyledMenuButton>
          <Box className="mobile-inspiration-universe" mt={4}>
            <StyledTypography
              variant="h5"
              component="h5"
              style={{
                fontSize: "16px",
                lineHeight: "20px",
                color: "rgba(132, 132, 132, 1)",
                textTransform: "none",
                marginBottom: "15px",
              }}>
              Par univers
            </StyledTypography>
            {InspirationData?.univers?.map((uniData: Record<string, any>, index: number) => (
              <SmartLink
                key={uniData?.label + index}
                to={uniData?.link || ""}
                onClick={() => onLinkClick(uniData)}
                styles={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "20px" }}>
                {uniData?.icon && (
                  <ImageLayout
                    src={storeUtil.getUrlPicture(`${uniData.icon}`, "")}
                    height={24}
                    width={24}
                    styles={{ margin: "unset" }}
                  />
                )}
                <StyledTypography
                  variant="body1"
                  component="p"
                  style={{ fontSize: "15px", fontWeight: "600", lineHeight: "20px" }}>
                  {uniData?.label}
                </StyledTypography>
              </SmartLink>
            ))}
          </Box>
          <Box className="mobile-inspiration-par-type" mt={4}>
            <StyledTypography
              variant="h5"
              component="h5"
              style={{
                fontSize: "16px",
                lineHeight: "20px",
                color: "rgba(132, 132, 132, 1)",
                textTransform: "none",
                marginBottom: "15px",
              }}>
              Par type
            </StyledTypography>
            {InspirationData?.type?.map((parTypeData: Record<string, any>, index: number) => (
              <SmartLink
                key={parTypeData?.label + index}
                to={parTypeData?.link || ""}
                onClick={() => onLinkClick(parTypeData)}
                styles={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "20px" }}>
                {parTypeData?.icon && (
                  <ImageLayout
                    src={storeUtil.getUrlPicture(`${parTypeData.icon}`, "")}
                    height={24}
                    width={24}
                    styles={{ margin: "unset" }}
                  />
                )}
                <StyledTypography
                  variant="body1"
                  component="p"
                  style={{ fontSize: "15px", fontWeight: "600", lineHeight: "20px" }}>
                  {parTypeData?.label}
                </StyledTypography>
              </SmartLink>
            ))}
          </Box>
        </Box>
      </MobileMenuWrapper>
    </StyledSwipeableDrawer>
  );
};

export default MobileInspirationsMenu;
